import { Swiper, Navigation, Pagination, EffectFade } from 'swiper/core';
Swiper.use([Navigation, Pagination, EffectFade]);

export default () => {

  const p = {}
  const init = () => {
    p.root = document.getElementById('photo-story');
    if (!p.root) {
      return;
    }
    console.log('init photo story', p);

    buildSwiper();
  }

  const buildSwiper = () => {
    const isPcMatchMedia = window.matchMedia('(min-width: 769px)');
    const container = p.root.querySelector('.at-pstory__container');
    const pagination = p.root.querySelector('.at-pstory__pagination');
    const prevBtn = p.root.querySelector('.at-pstory__btn._prev');
    const nextBtn = p.root.querySelector('.at-pstory__btn._next');

    const swiperOption = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: pagination,
        type: 'fraction',
        currentClass: 'at-pstory__pagination-current',
        totalClass: 'at-pstory__pagination-total',
        formatFractionCurrent: (number) => {
          return ('0' + number).slice(-2);
        }
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        slideChange: () => {
          if (isPcMatchMedia.matches) {
            return;
          }
          const stickyHeader = document.querySelector('.l-header._fixed');
          const pRootPagePos = p.root.getBoundingClientRect().top + (window.pageYOffset || window.scrollY);
          const scrollPos = pRootPagePos - stickyHeader.clientHeight;
          window.scrollTo({
            left: 0,
            top: scrollPos,
            behavior: 'smooth'
          })
        }
      }
    }

    p.swiper = new Swiper(container, swiperOption)
  }

  init();

  return {}
}
